// src/api/encounterApi.ts

import { createAsyncThunk } from "@reduxjs/toolkit"
import { serverApi, getAuthHeaders, handleApiResponse, handleReferenceResponse, queApi } from "@core/api/core"
import { SugaSerializer, SugaListResponse } from "@/types/suga"
import { CommonReferenceResponse } from "@/types/common"

export const fetchSugas = createAsyncThunk<SugaSerializer[], void, { rejectValue: string }>("suga/fetchSugas", async (_, { rejectWithValue }) => {
  try {
    const requestUrl = `/reference/suga/`
    const response = await queApi.get<CommonReferenceResponse>(requestUrl)

    const { columns, results } = handleReferenceResponse(response)

    const datas: SugaSerializer[] = results.map(row => {
      // columns[i] ↔ row[i] 매핑
      const obj = Object.fromEntries(columns.map((col, i) => [col, row[i]])) as Record<string, number | string>

      return {
        sugaCode: String(obj["sugaCode"]),
        sugaCodePrefix: String(obj["sugaCodePrefix"]),
        sugaCodeSuffix: String(obj["sugaCodeSuffix"]),
        sugaName: String(obj["sugaName"]),
        sugaNameExtra: String(obj["sugaNameExtra"]),
        sugaDanga: Number(obj["sugaDanga"]),
        sugaGachiJumsu: Number(obj["sugaGachiJumsu"]),
      }
    })
    // console.log("fetchAcupoints", sugas)
    return datas
  } catch (error: any) {
    return rejectWithValue(error.message || "수가 정보 조회 중 오류가 발생했습니다.")
  }
})
